import { Link } from "react-router-dom";
import { QrCodeIcon, HeartIcon } from "@heroicons/react/24/outline";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 text-center md:text-left">
          <div>
            <div className="flex items-center justify-center md:justify-start space-x-2 mb-4">
              <img src="/logo-icon.svg" alt="Prindox Logo" className="w-8 h-8 object-contain" />
              <span className="text-xl font-bold">Prindox</span>
            </div>
            <p className="text-gray-400 mb-4">
              Making document printing accessible, instant, and hassle-free for everyone.
            </p>
            <div className="flex items-center justify-center md:justify-start space-x-4">
              <HeartIcon className="w-5 h-5 text-red-500" />
              <span className="text-sm text-gray-400">Made with love in India</span>
            </div>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#features" className="hover:text-white transition-colors">Features</a></li>
              <li><a href="#how-it-works" className="hover:text-white transition-colors">How it Works</a></li>
              <li><Link to="/find-shops" className="hover:text-white transition-colors">Find Shops</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/help" className="hover:text-white transition-colors">Help Center</Link></li>
              <li><Link to="/terms" className="hover:text-white transition-colors">Terms</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition-colors">Privacy</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Get Started</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/register" className="hover:text-white transition-colors">Sign Up</Link></li>
              <li><Link to="/login" className="hover:text-white transition-colors">Sign In</Link></li>
              <li><Link to="/send" className="hover:text-white transition-colors">Print Now</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center text-gray-400 space-y-4 md:space-y-0">
          <p>&copy; 2024 Prindox. All rights reserved.</p>
          <div className="flex items-center space-x-1 text-sm">
            <span>Designed & Developed by</span>
            <a 
              href="https://github.com/recscse" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 font-medium transition-colors"
            >
              Brijesh Yadav
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}